import { loaderReducer } from '../loader/loader.reducer';
import { ScopedLoaderState } from './scoped-loader.state';
import { Action } from '@ngrx/store';
import {EntityLoaderMeta} from "../entity-loader";

export const initialScopedLoaderState: ScopedLoaderState<any> = {};

export interface ProductMeta extends EntityLoaderMeta {
  scope?: string;
}

export interface EntityScopedLoaderAction extends Action {
  readonly payload?: any;
  readonly meta?: ProductMeta;
}

/**
 * Higher order reducer designed to add scope support for loader reducer
 *
 * @param entityType
 * @param reducer
 */

export function scopedLoaderReducer<T>(
  entityType: string,
  reducer?: (state: T, action: Action) => T
): (
  state: ScopedLoaderState<T>,
  action: EntityScopedLoaderAction
) => ScopedLoaderState<T> {
  const loader = loaderReducer<T>(entityType, reducer);

  return (
    state: ScopedLoaderState<T> = initialScopedLoaderState,
    action: EntityScopedLoaderAction
  ): ScopedLoaderState<T> => {
    if (action && action.meta && action.meta.entityType === entityType) {
      return {
        ...state,
        [action.meta.scope ?? '']: loader(state[action.meta.scope], action),
      };
    }
    return state;
  };
}
